// extracted by mini-css-extract-plugin
export default {"TextContainer":"Text_TextContainer__ZPsN8","Text":"Text_Text__VM7fv","Title":"Text_Title__hg7Q9"};